import {Navigate, useParams} from 'react-router-dom';

const Index = () => {
    let page = 'din-bil'

    // Nyckeln läggs inte i adressen (den skulle hamna i GA4); HjulskifteUpdate
    // läser den från react_data.
    if(window.react_data.time_update_key) {
        page = 'andra-tid-hjulskifte'
    }

    const navigate = '/' + page

    return (
        <div>
            {<Navigate to={navigate} />}
        </div>
    );
};

export default Index
